<template>
  <div class="col-md-6 col-sm-12 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Agregar proyección de venta</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <div class="row mb-0">
          <div class="col-sm-7">
            <h5 class="mb-0">Productor</h5>
            <span class="font-weight-normal">{{ producer }}</span>
          </div>
          <div class="col-sm-5 text-right">
            <h5 class="mb-0">Campaña</h5>
            <span class="font-weight-normal">{{ campaign.name }}</span>
          </div>
        </div>

        <hr class="mt-3" />
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Mes de Compra (*) </label>

                <el-select
                  v-model="formData.period"
                  v-validate="modelValidations.period"
                  autocomplete="off"
                  filterable
                  name="period"
                  placeholder="Mes de Compra"
                >
                  <el-option v-for="month in 12" :key="month" :label="month" :value="month"> </el-option>
                </el-select>

                <small v-show="period.invalid" class="text-danger">
                  {{ getError('perdiod') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Cultivo</label>

                <el-select
                  v-model="formData.crop"
                  v-validate="modelValidations.crop"
                  autocomplete="off"
                  filterable
                  name="crop"
                  placeholder="Cultivo"
                  @change="formData.variety = null"
                >
                  <el-option
                    v-for="option in cropsOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="crop.invalid" class="text-danger">
                  {{ getError('crop') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Variedad (*)</label>

                <el-select
                  v-model="formData.variety"
                  v-validate="modelValidations.variety"
                  :disabled="!formData.crop"
                  autocomplete="off"
                  filterable
                  name="variety"
                  placeholder="Variedad"
                >
                  <el-option
                    v-for="option in varietiesOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  >
                  </el-option>
                </el-select>

                <small v-show="variety.invalid" class="text-danger">
                  {{ getError('variety') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">
                  Cantidad <small v-if="formData.crop">[{{ unitMeasure }}]</small> (*)
                </label>

                <el-input
                  v-model="formData.quantity"
                  v-validate="modelValidations.quantity"
                  name="quantity"
                  placeholder="Cantidad"
                >
                </el-input>

                <small v-show="quantity.invalid" class="text-danger">
                  {{ getError('quantity') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="control-label"> Variedad Competidora </label>

                <el-input
                  v-model="formData.competitorVariety"
                  v-validate="modelValidations.competitorVariety"
                  name="competitorVariety"
                  placeholder="Variedad Competidora"
                >
                </el-input>

                <small v-show="competitorVariety.invalid" class="text-danger">
                  {{ getError('competitorVariety') }}
                </small>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="control-label"> Cantidad a Sembrar </label>

                <el-input
                  v-model="formData.competitorQuantity"
                  v-validate="modelValidations.competitorQuantity"
                  name="competitorQuantity"
                  placeholder="Cantidad a sembrar"
                >
                </el-input>

                <small v-show="competitorQuantity.invalid" class="text-danger">
                  {{ getError('competitorQuantity') }}
                </small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';
import { mapFields } from 'vee-validate';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    producer: {
      type: String,
      default: null,
    },

    campaign: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      crops: [],
      varieties: [],
      validated: false,
      formData: {
        period: null,
        quantity: null,
        crop: null,
        campaign: this.campaign.id,
        variety: null,
        competitorVariety: null,
        competitorQuantity: null,
      },

      modelValidations: {
        variety: {
          required: true,
        },

        period: {
          required: true,
        },

        quantity: {
          required: true,
          numeric: true,
        },

        competitorVariety: {},
        competitorQuantity: {
          numeric: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['quantity', 'crop', 'variety', 'period', 'competitorQuantity', 'competitorVariety']),
    unitMeasure() {
      return this.crops.find((c) => c.id === this.formData.crop).unit;
    },

    cropsOptions() {
      let crops = this.campaign.crops;
      crops = crops.filter((crop) => crop.forSale);
      return this.$selectOptions(crops, { sort: true });
    },

    varietiesOptions() {
      let varieties = this.varieties;
      if (this.formData.crop) {
        varieties = varieties.filter((variety) => variety.cropId === this.formData.crop);
      }
      return this.$selectOptions(varieties, { sort: true });
    },
  },

  created() {
    this.fetchCrops();
    this.fetchVarieties();
  },

  methods: {
    fetchCrops() {
      const params = {
        'filter[crops_for_sale]': true,
      };
      this.$services
        .resource('crops')
        .get(params)
        .then((res) => res.data.data)
        .then((data) => (this.crops = data.crops));
    },

    fetchVarieties() {
      const params = {
        'filter[varieties_for_sale]': true,
        include: ['crop'],
      };
      this.$services
        .resource('varieties')
        .get(params)
        .then((res) => res.data.data)
        .then((data) => (this.varieties = data.varieties));
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit()
        .then((res) => {
          if (res) {
            this.$emit('save', this.formData);
          }
        })
        .catch((e) => {});
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>
